import { render } from "./CorporateAccountingView.vue?vue&type=template&id=4f4d4b85"
import script from "./CorporateAccountingView.vue?vue&type=script&lang=js"
export * from "./CorporateAccountingView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__